import React from 'react';
import { Box, Typography, Paper, Stack } from '@mui/material';
import { IContestRequest } from '../../redux/requests/types';
import CloseIcon from '../CustomSVGIcons/CloseIcon';
import CustomButton from '../Button/CustomButton';
import { NewReleases } from '@mui/icons-material';

export interface IRequestUpdateBoxProps {
    request: IContestRequest;
    onClose?: () => void;
    onWithdraw: (request: IContestRequest) => void;
    onResubmit: (request: IContestRequest) => void;
    mode?: 'light' | 'dark'; // Optional mode prop
}

const RequestUpdateBox: React.FC<IRequestUpdateBoxProps> = ({
    request,
    onClose,
    onWithdraw,
    onResubmit,
    mode = 'light',
}) => {
    const isDark = mode === 'dark';

    const colors = {
        background: isDark ? '#1E1E1E' : '#FFFFFF',
        border: isDark ? '#2D2D2D' : '#E0E0E0',
        messageBg: isDark ? '#2A2A2A' : '#F5F5F5',
        text: isDark ? '#F0F0F0' : '#1A1A1A',
        subtext: isDark ? '#BBBBBB' : '#555555',
        highlight: '#E53935', // 🔴 Red tone
        buttonText: '#FFFFFF',
        withdrawText: isDark ? '#BBBBBB' : '#555555',
    };

    return (
        <Paper
            elevation={0}
            sx={{
                bgcolor: colors.background,
                border: `1px solid ${colors.border}`,
                borderRadius: 2,
                px: 3,
                py: 2,
                my: 2,
            }}>
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <NewReleases sx={{ color: colors.highlight, fontSize: 20 }} />
                    <Typography sx={{ color: colors.highlight, fontWeight: 600, fontSize: 16 }}>
                        Request Update
                    </Typography>
                </Stack>
                <CloseIcon onClick={onClose} stroke={colors.text} style={{ cursor: 'pointer' }} />
            </Box>

            {/* Message Box */}
            <Box
                sx={{
                    backgroundColor: colors.messageBg,
                    borderRadius: 1,
                    px: 2,
                    py: 1.5,
                    mb: 3,
                }}>
                <Typography sx={{ color: colors.text, fontSize: 14 }}>
                    {request.resolution_message || 'No update message provided.'}
                </Typography>
            </Box>

            {/* Action Buttons */}
            <Box display="flex" justifyContent="flex-end" gap={2}>
                <CustomButton
                    label="Withdraw"
                    onClick={() => onWithdraw(request)}
                    buttonProps={{ variant: 'text' }}
                    customStyle={{
                        backgroundColor: 'transparent',
                        padding: '6px 12px',
                    }}
                    textStyle={{
                        color: colors.withdrawText,
                        fontSize: 14,
                        fontWeight: 500,
                    }}
                />
                <CustomButton
                    label="Resubmit"
                    onClick={() => onResubmit(request)}
                    customStyle={{
                        backgroundColor: colors.highlight,
                        color: colors.buttonText,
                        borderRadius: 6,
                        padding: '6px 20px',
                        boxShadow: isDark ? '0 2px 6px rgba(229, 57, 53, 0.3)' : '0 2px 6px rgba(229, 57, 53, 0.15)',
                        cursor: 'pointer',
                    }}
                    textStyle={{
                        fontSize: 14,
                        fontWeight: 600,
                    }}
                />
            </Box>
        </Paper>
    );
};

export { RequestUpdateBox };
